<template>
  <div>
    <div v-if="assessData">
      <div id="hldResult">
        <div class="title">
          霍兰德高考志愿倾向测试结果报告
        </div>
        <div v-if="this.report">
          <div id="tabs-1">
            <div class="pctitle">
              介绍</div>
            <div class="career-number" v-html="this.report.selfImprovement">
            </div>
          </div>
          <div id="tabs-1">
            <div class="pctitle">
              意义</div>
            <div class="career-number" v-html="this.report.significance">
            </div>
          </div>
          <div id="tabs-1">
            <div class="pctitle">
              你的霍兰德代码</div>
            <div class="career-number">{{ this.report.appraise }}
            </div>
            <div id="main"></div>
          </div>

          <div id="tabs-1">
            <div class="pctitle">
              霍兰德代码的特点</div>
            <div class="career-number">{{ this.report.feature }}
            </div>
          </div>

          <div id="tabs-1">
            <div class="pctitle">
              推荐的专业</div>
            <div class="career-number" v-html="this.report.referenceMajor">
            </div>

          </div>



        </div>
      </div>
    </div>
    <div v-else>
      <div style="font-size: 180px;text-align: center;color: #e3e3e3;" @click="dialogVisible = true">+</div>
      <div class="invite" @click="dialogVisible = true">邀请学员进行测评</div>
    </div>

    <el-dialog :visible.sync="dialogVisible" title="测评链接" append-to-body width="700px">

      <div>
        {{ "https://daoshi.bkgaoshou.com/#/assess?id=" + userInfo.id }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyText">复制</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    userInfo: Object
  },
  data() {
    return {
      status: false,
      assessData: null,
      dialogVisible: false,
      report: {}
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.$fecth.post("ceping/get_hld_report_info", { user_id: this.userInfo.id }).then((res) => {
      let { code, msg, data } = res;
      if (data) {
        this.assessData = true
        this.report = JSON.parse(data.report)
        console.log(this.report)
        this.createEcharts();
      }
      console.log(code, msg, data)
    });
  },
  methods: {
    copyText() {
      let oInput = document.createElement("input"); //创建一个隐藏input（重要！）
      oInput.value =
        "https://daoshi.bkgaoshou.com/#/assess?id=" + this.userInfo.id
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      alert("复制成功");
      this.dialogVisible = false
    },
    dayin() {
    }
  },
};
</script>

<style scoped lang='less'>
#pdfDom {
  width: 100%;
  min-height: 98vh;
}

本科一批 .invite {
  text-align: center;
  color: #5896f9;
  padding: 3px 7px;
  margin-bottom: 20px;
  margin-top: 40px;
}

</style>

<style scoped lang='less'>
.title {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #4870f6;
  color: white;
  padding: 16px 0;
  font-size: 30px;
}

#main {
  width: 100%;
  margin-bottom: 30px;
  padding-bottom: 40px;
  min-height: 300px;
}

#hldResult {
  width: 1200px;
  margin: 20px auto 20px;

}

#tabs-1 {
  box-shadow: 0px 0px 5px #dddddd;
  margin-bottom: 30px;

  // text-indent: 25px;
}

.pctitle {
  line-height: 50px;
  height: 50px;
  padding: 0 30px;
  color: black;
  border-bottom: 2px solid #4870f6;
  margin-bottom: 20px;
  // background: #4870f6;

}

.career-number {
  padding: 0 30px;
  line-height: 50px;
  font-size: 24px;
  margin: 0;
  padding-bottom: .12em;
}
</style>
